import React from "react";

const ContactOne = () => {
  return (
    <section className="contact_form_area">
      <div className="contact_form_width">
        <h1 className="contact_map_title text-center">
          Naš rad će zagarantovano ispuniti vaša očekivanja.
        </h1>
        <div id="map">
          <iframe
            title="template google map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3357.6831157102165!2d20.47296519080969!3d44.7453812964809!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a711305099007%3A0x76bc045d9dd8d9e1!2sBulevar%20JNA%2022%2C%20Beograd!5e1!3m2!1sen!2srs!4v1768078689125!5m2!1sen!2srs"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ContactOne;